<template>
  <div class="backStack-issue-wrap informationCreate">
    <!-- <div class="form-scroll-wrap" :style="contentStyle"> -->
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel" >
    </From>
    <UserInfos ref="userInfos" :infos="userInfo"></UserInfos>
    <!-- </div> -->
    <div class="backStack-issue-footer-wrap">
      <div class="read-wrap">
        <a-checkbox @change="readChange"></a-checkbox>
        <span class="text">我已阅读并同意《服务信息发布规则》</span>
      </div>
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit(0)">提交审核</a-button>
        <span class="text" >温馨提示：服务信息提交后，将由相关人员审核后，方可发布！</span >
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/mixins/backStack'
import UserInfos from '../../components/userInfos/index.vue'
import { formRules, formRows, userInfo } from './configs/formOptions.js'
import { serverInfoUpdate, serverInfoDetail } from '@/api/serverInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      userInfo,
      loading: true,
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {},
      contentStyle: '',
      editId: null,
      isRead: false
    }
  },
  async created() {
    this.initSetting()
      const { id } = this.$route.query
      const {data} = await serverInfoDetail(id)
      this.editId = id
      this.dealInfo('userInfo', data.user)  // 处理用户信息
      this.handleResult(data) // 处理结果为想要的格式
  },
  components: {
    From,
    UserInfos
  },
  methods: {
    handleResult(instance) {
      const { fileVo, ...otherParams} = instance
      this.defaultModel = {
        ...otherParams,
        picPath: fileVo,
      }
    },
    initSetting() {
      this.initDom()
    },
    initDom() {
      this.contentStyle ={ height: `calc(100vh - 360px)` }
    },
    // 处理静态信息
    dealInfo(type, result) {
      if(!result) return
      if(!this[type]) return
      this[type].forEach(item => {
        const {key} = item
        const v = result[key] || '-'
        item.value = v
      })
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    async toAudit() {
      const v = this.$refs.formRef.validatedForm()
      if (!v) return
      if (!this.isRead) {
        return this.$apiStatusHandler(1, '请勾选《需求发布规则》')
      }
      try {
        const { ...formValue} = this.$refs.formRef.formModel
        const pic = this.handlerPicPathIds(formValue).join(',')
        const params = {
          ...formValue,
          pic,
          id: this.editId
        }
        const {msg, code} = await serverInfoUpdate(params)
        this.$apiStatusHandler(code, msg)
        this.$router.go(-1)
      } catch (error) {
        console.log(error)
        this.$apiStatusHandler(99, error)
      }
    },
    handlerPicPathIds(instance) {
      const { picPath } = instance
      if(!picPath) return []
      return picPath.reduce((pre, item) => {
        if(item.response) {
          const {fileId} = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.id)
        }
        return pre
      }, [])
    },
  }
}
</script>
